/**
 * Created by vikash on 24/05/16.
 */
(function() {
  'use strict';
  angular.module('dtmService.module').constant('dtmServiceConstants', {
    dtmRules: {
      receivePUKCode: {
        name: 'receive PUK code',
        defaultServerError: 'Error retrieving PUK'
      },
      updateVMPassword: {
        name: 'update vm password',
        defaultServerError: 'Error updating voicemail password.'
      },
      makePayment: {
        name: 'make a payment',
        paymentType: {
          parameterName: 'PaymentType',
          debit: 'Debit',
          credit: 'Credit'
        },
        interacPaymentEligibilityError: 'Error occurred determining Interac Payment Eligibility.',
        creditCardPaymentError: 'Error occurred processing credit card payment.'
      },
      referFriend: {
        name: 'refer a friend',
        defaultServerError: 'Error occurred referring a friend.'
      },
      reportLostDevice: {
        name: 'report lost device',
        defaultServerError: 'Error occurred requesting device suspension.'
      },
      availCheckOpen: {
        name: 'availcheck-open'
      },
      availCheckYes: {
        name: 'availcheck-yes'
      },
      availCheckNo: {
        name: 'availcheck-no'
      },
      changeContactInformation: {
        name: 'change contact information',
        defaultServerError: 'Error occurred changing contact information.'
      },
      changeBillingAddress: {
        name: 'change billing address',
        defaultServerError: 'Error occurred changing billing address.'
      },
      changeBillingType: {
        parameterName: 'BillingType',
        name: 'change billing type',
        billingTypeRuleName: 'actv-myfido-billing type'
      },
      forgotPassword: {
        name: 'forgot password',
        groupFailureError: 'Group failure error',
        defaultServerError: 'Error occurred on server side in forgot password process'
      },
      registration: {
        name: 'registration',
        billingTypeRuleName: 'actv-myfido-billing type',
        defaultServerError: 'Error occurred on server side in registration process'
      },
      changeUsername: {
        name: 'change username'
      },
      changePassword: {
        name: 'change password',
        defaultServerError: 'Error occurred in Change Password process'
      },
      facebookLinkStart: {
        ruleName: 'actv-myfido-link facebook account started'
      },
      facebookLinkComplete: {
        ruleName: 'actv-myfido-link facebook account completed'
      },
      facebookUnlinkStart: {
        ruleName: 'actv-myfido-unlink facebook account started'
      },
      facebookUnlinkComplete: {
        ruleName: 'actv-myfido-unlink facebook account completed'
      },
      dtmFacebookRegistrationStart: {
        ruleName: 'actv-myfido-register facebook account started'
      },
      dtmFacebookRegistrationComplete: {
        ruleName: 'actv-myfido-register facebook account completed'
      },
      updateMOP: {
        name: 'update method of payment',
        defaultServerError: 'Error updating method of payment'
      },
      updateSimCard: {
        name: 'Update SIM Card',
        defaultServerError: 'Error updating sim card'
      },
      switchOLBBannerStart: {
        name: 'actv-myaccount-go paperless banner-started'
      },
      switchOLBBannerComplete: {
        name: 'actv-myaccount-go paperless banner-completed'
      },
      switchOLBBannerError: {
        name: 'actv-myaccount-go paperless banner error',
        eVar: 'error',
        defaultServerError: 'Error occurred while switch to OLB on overview page using banner'
      },
      changeAppointment: {
        name: 'Change Appointment',
        errorRuleName: 'actv-myfido-change appointment error',
        eVar: 'error',
        defaultServerError: 'Error occurred in Change Technician Appointment process'
      },
      dtmInternetResetModem: {
        ruleName: 'Restart Your Modem',
        errorRuleName: 'actv-myfido-restart your modem error',
        eVar: 'error',
        defaultServerError: 'Error occurred in the Reset modem process'
      },
      dtmCancelInternet: {
        ruleName: 'Cancel Internet',
        errorRuleName: 'actv-myfido-cancel internet error',
        eVar: 'error',
        defaultServerError: 'Error occurred in the cancel internet process'
      },
      buyInternet: {
        addToCart: {
          ruleName: 'fido-internet-cart-summary'
        },
        checkout: {
          ruleName: 'fido internet-create user'
        },
        review: {
          ruleName: 'fido internet-order-review',
          fulfillmentParamName: 'FulfillmentType',
          paymentParamName: 'PaymentOptions',
          shipToAddress: 'ship to address',
          pickupAtStore: 'pick up at store',
          techInstall: 'tech install',
          takeItWithYou: 'take it with you'
        },
        creditCheck: {
          ruleName: 'fido internet - step 2'
        },
        installation: {
          ruleName: 'fido internet - step 3'
        },
        paymentOptions: {
          ruleName: 'fido internet - step 4'
        },
        confirmOrder: {
          ruleName: 'fido internet - step 6',
          orderNumber: 'OrderNumber'
        },
        selectedProduct: 'ProductSKU',
        productPrice: 'price'
      },
      genericBBError: {
        ruleName: 'myaccount-generic error',
        defaultServerError: 'Error occurred during view bill process',
        eVar: 'error'
      },
      resetPassword: {
        startRule: 'actv-myaccount-reset password-started',
        completeRule: 'actv-myaccount-reset password-completed',
        errorRule: 'actv-myaccount-reset password-error',
        defaultServerError: 'Error occurred during reset password',
        eVar: 'error'
      },
      selectedBAN: {
        ruleName: 'myfido-BAN',
        parameterName: 'selectedBAN'
      },
      selectedCTN: {
        ruleName: 'myfido-CTN',
        parameterName: 'selectedCTN'
      },
      dtmLinkAccount: {
        startRule: 'actv-myaccount-link account-started',
        completeRule: 'actv-myaccount-link account -completed',
        errorRule: 'actv-myaccount-link account-error',
        ruleName: 'link account',
        eVar: 'error',
        defaultServerError: 'Error occurred during Link Account process'
      },
      dtmDownloadBill: {
        ruleName: 'pasv-myaccount-download bill',
        billType: {
          parameterName: 'Download Bill',
          pdf: 'PDF',
          excel: 'Excel',
          print: 'Print',
          csv: 'CSV'
        }
      }
    },
    actions: {
      start: 'started',
      startEvent: 'start',
      completeEvent: 'complete',
      complete: 'completed',
      error: 'error'
    },
    type: {
      active: 'actv',
      passive: 'pasv'
    },
    project: {
      myAccount: 'myaccount'
    },
    dataLayerTrack: {
      account: {
        type: 'consumer'
      },
      deviceType: {
        mobile: 'mobile',
        desktop: 'desktop'
      },
      errorType: {
        user: 'user',
        form: 'form',
        http: 'http',
        selfServe: 'self serve',
        signIn: 'signin',
        location: 'location',
        credit: 'credit',
        selfServeTransaction: 'self serve'
      },
      interaction: {
        changeCtn: {
          name: 'view different numbers',
          type: 'link'
        }
      },
      page: {
        makeAPayment: {
          start: {
            name: 'payment',
            hierarchy: ['myaccount', 'pay now']
          },
          details: {
            name: 'payment details',
            hierarchy: ['myaccount', 'pay now']
          },
          payViaBank: {
            name: 'pay via bank',
            hierarchy: ['myaccount', 'pay now']
          },
          review: {
            name: 'review',
            hierarchy: ['myaccount', 'pay now']
          },
          complete: {
            name: 'confirmation',
            hierarchy: ['myaccount', 'pay now']
          },
          error: {
            name: 'error',
            hierarchy: ['myaccount', 'pay now']
          },
          paymentType: {
            interac: 'Interac',
            credit: 'credit',
            debit: 'debit',
            bank: 'Online Bank - '
          },
          errorType: {
            payment: 'payment',
            preAuthPayment: 'switch pre-auth',
            interacEligibility: 'interac eligibility',
            interacPaymentFailure: 'Interac payment',
            interacPaymentConfirm: 'Interac confirm'
          }
        },
        changeCallerID: {
          start: {
            name: 'change your callerID',
            hierarchy: ['myaccount', 'change callerid']
          },
          complete: {
            name: 'confirmation',
            hierarchy: ['myaccount', 'change callerid']
          },
          error: {
            name: 'error',
            hierarchy: ['myaccount', 'change callerid']
          },
          errorType: {
            updateFailure: 'callerid'
          }
        },
        changeCtn: {
          start: {
            name: 'step 1 - select location',
            hierarchy: ['myaccount', 'change phone number']
          },
          selectNumber: {
            name: 'step 2 - select phone number',
            hierarchy: ['myaccount', 'change phone number']
          },
          review: {
            name: 'step 3 - review',
            hierarchy: ['myaccount', 'change phone number']
          },
          complete: {
            name: 'step 4 - confirmation',
            hierarchy: ['myaccount', 'change phone number']
          },
          error: {
            name: 'error',
            hierarchy: ['myaccount', 'change phone number']
          },
          errorType: {
            fetchBaseLocation: 'baselocation',
            fetchCityList: 'citylist',
            changeCtnCount: 'changectncount',
            retrieveNewNumbers: 'newnumbers',
            submit: 'submit'
          }
        },
        saveMultipleBill: {
          name: 'save bill pdf',
          hierarchy: ['my-account', 'view-invoice-history']
        },
        continueToRepairPortal: {
          start: {
            name: 'continue to repair portal',
            hierarchy: ['F:home', 'my-account', 'wireless', 'dashboard']
          },
          complete: {
            name: 'confirmation',
            hierarchy: ['F:home', 'my-account', 'wireless', 'dashboard']
          },
          error: {
            name: 'system error modal',
            hierarchy: ['F:home', 'my-account', 'wireless', 'dashboard']
          },
          errorType: {
            updateFailure: 'repairPortal'
          }
        }
      },
      selfServe: {
        makeAPayment: {
          name: 'bill pay',
          type: 'transaction'
        },
        changeCallerID: {
          name: 'change caller id',
          type: 'transaction'
        },
        changeCtn: {
          name: 'change my number',
          type: 'transaction'
        }
      },
      apiErrorTracking: [
        {
          flow: 'changenumber',
          changectncount: {
            errorMessageKey: 'global.error.label.ctnExceedMessage',
            pageView: true
          },
          errorMessageKey: 'global.error.inline.generic',
          pageName: {
            name: 'error',
            hierarchy: ['myaccount', 'change phone number']
          }
        }
      ],
      siteName: 'F',
      userType: {
        consumer: 'consumer',
        agent: 'agent'
      },
      basicPayloadSections: ['site', 'pageView', 'pageInfo', 'account'],
      basicPayloadInfo: ['site', 'pageInfo', 'account'],
      basicPayload: {
        site: 'site',
        pageView: 'pageView',
        pageInfo: 'pageInfo',
        account: 'account',
        interAction: 'interaction'
      }
    }
  });
})();
